module.exports = __webpack_public_path__ + "9528bf8178f4ebb546839da9ba20d32b.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon-amex.svg
// module id = WAMM
// module chunks = 5